import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { ItemGroup } from '@atlaskit/item';

var DropdownItemGroup = function (_Component) {
  _inherits(DropdownItemGroup, _Component);

  function DropdownItemGroup() {
    _classCallCheck(this, DropdownItemGroup);

    return _possibleConstructorReturn(this, (DropdownItemGroup.__proto__ || _Object$getPrototypeOf(DropdownItemGroup)).apply(this, arguments));
  }

  _createClass(DropdownItemGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          elemAfter = _props.elemAfter,
          title = _props.title;

      return React.createElement(
        ItemGroup,
        { elemAfter: elemAfter, title: title, role: 'menu' },
        children
      );
    }
  }]);

  return DropdownItemGroup;
}(Component);

export default DropdownItemGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dropdown-menu/dist/esm/components/group/DropdownItemGroup.js
// module id = 109
// module chunks = 0